import Vue from 'vue'
import Vuex from 'vuex'
import { secondsToFullTimestamp, secondsToFormatDateInput} from '@/Helper.js' 
import { documentsOperationsCollection, documentsCollection, db, customAuth } from '../../FirebaseConfig';
Vue.use(Vuex)
export default {
  namespaced:true,
    state: {
      loading: true, 
    },
    mutations: {
      onLoading : state => state.loading = true,
      offLoading : state => state.loading = false,
  },
  actions:{
    closeDocument:(context, key)=>documentsOperationsCollection.doc(key).update({isClose: true}),
  }
}



